__webpack_require__.p = "/assets/turbo/79344c8d/quellede/_next/";